import { render, staticRenderFns } from "./regularidade-fiscal.vue?vue&type=template&id=dec0cfca&scoped=true"
import script from "./regularidade-fiscal.vue?vue&type=script&lang=js"
export * from "./regularidade-fiscal.vue?vue&type=script&lang=js"
import style0 from "./regularidade-fiscal.vue?vue&type=style&index=0&id=dec0cfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec0cfca",
  null
  
)

export default component.exports